export default __webpack_public_path__ + "static/media/Esme 9781408324974.6b77fd73.jpg";